// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"7e7b46e6","344":"3bf39d16","453":"6264690d","496":"3e4eb73c"}[chunkId] + ".chunk.js";
};